<template>
  <div class="class-management">
    <nav class="class-breadcrumb" aria-label="页面位置"><router-link to="/home/index">首页</router-link><v-icon size="13">mdi-chevron-right</v-icon><span>教务中心</span><v-icon size="13">mdi-chevron-right</v-icon><span>班级管理</span></nav>
    <header class="class-page-heading">
      <div><h1>班级管理</h1><p>查看班级安排、授课老师与课次，轻松管理每一个班。</p></div>
      <v-btn depressed color="#d9363e" dark @click="createClass.show=true"><v-icon left size="18">mdi-calendar-plus</v-icon>开班排课</v-btn>
    </header>
    <section class="class-filter-panel" aria-label="班级筛选">
      <div class="class-filter-heading"><h2>筛选班级</h2><span>按课程、状态和剩余课次查找班级</span></div>
      <form @submit.prevent="queryClicked">
        <div class="class-filters">
          <div><label for="class-course-filter">所属课程</label><v-select id="class-course-filter" :items="selectCourseList" v-model="query.courseId" item-text="courseName" item-value="id" placeholder="全部课程" aria-label="所属课程" dense outlined clearable hide-details color="#d9363e" /></div>
          <div><label for="class-name-filter">班级名称</label><v-text-field id="class-name-filter" v-model="query.className" placeholder="请输入班级名称" aria-label="班级名称" dense outlined clearable hide-details color="#d9363e" /></div>
          <div><label for="class-status-filter">班级状态</label><v-select id="class-status-filter" :items="statusItems" v-model="query.status" item-text="statusName" item-value="id" aria-label="班级状态" dense outlined hide-details color="#d9363e" /></div>
          <div class="class-date-filter"><span class="class-field-label">创建时间</span><div class="class-range">
            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }"><v-text-field v-model="query.start" placeholder="开始日期" aria-label="开始日期" readonly v-bind="attrs" v-on="on" dense outlined clearable hide-details color="#d9363e" /></template>
              <v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" />
            </v-menu><span>至</span>
            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }"><v-text-field v-model="query.end" placeholder="结束日期" aria-label="结束日期" readonly v-bind="attrs" v-on="on" dense outlined clearable hide-details color="#d9363e" /></template>
              <v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" />
            </v-menu>
          </div></div>
          <div class="class-remaining-filter"><span class="class-field-label">剩余课次</span><div class="class-range"><v-text-field v-model="query.minLessonCount" placeholder="最少" aria-label="最少剩余课次" dense outlined clearable hide-details color="#d9363e" /><span>至</span><v-text-field v-model="query.maxLessonCount" placeholder="最多" aria-label="最多剩余课次" dense outlined clearable hide-details color="#d9363e" /></div></div>
        </div>
        <div class="class-filter-bottom"><span><v-icon size="15">mdi-school-outline</v-icon>当前校区的班级与教学安排</span><div><v-btn text class="class-reset" :disabled="query.loading" @click="resetQuery"><v-icon left size="16">mdi-refresh</v-icon>重置</v-btn><v-btn depressed class="class-query" type="submit" :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询班级</v-btn></div></div>
      </form>
    </section>
    <section class="class-list-panel" aria-label="班级列表" :aria-busy="query.loading">
      <div class="class-list-toolbar"><h2>班级列表</h2><span class="class-count"><b>{{data.total}}</b> 个班级</span></div>
      <v-progress-linear v-if="query.loading" indeterminate color="#d9363e" height="2" aria-label="正在加载班级" />
      <div class="class-table-scroll" tabindex="0" aria-label="班级列表，可横向滚动">
        <table class="class-table">
          <colgroup><col class="class-col-name"><col class="class-col-consume"><col class="class-col-teacher"><col class="class-col-room"><col class="class-col-plan"><col class="class-col-status"><col class="class-col-count"><col class="class-col-count"><col class="class-col-count"><col class="class-col-action"></colgroup>
          <thead><tr><th scope="col">班级 / 课程</th><th scope="col">扣费方式</th><th scope="col">授课老师</th><th scope="col">教室</th><th scope="col">上课时间</th><th scope="col">状态</th><th scope="col" class="class-number-cell">学员数</th><th scope="col" class="class-number-cell">总课次</th><th scope="col" class="class-number-cell">已上课次</th><th scope="col">操作</th></tr></thead>
          <tbody>
            <tr v-for="item in data.list" :key="item.id">
              <td><button type="button" class="class-name" @click="showDetail(item)">{{item.className || '未命名班级'}}</button><div class="class-course">{{item.courseName || '—'}}</div></td>
              <td><span class="class-consume" :class="{'class-consume-cash':item.consumeType === '2'}">{{consumeTypeName(item.consumeType)}}</span></td>
              <td><div class="class-teacher"><span class="class-role">主课</span>{{item.teacherName || '—'}}</div><div v-if="item.secondTeacherName || item.thirdTeacherName" class="class-assist"><span class="class-role">助教</span>{{[item.secondTeacherName,item.thirdTeacherName].filter(Boolean).join('、')}}</div></td>
              <td>{{item.roomName || '—'}}</td>
              <td><div v-if="item.timePlanList && item.timePlanList.length" class="class-plans"><div v-for="(plan,idx) in item.timePlanList" :key="idx" class="class-plan"><span>{{plan.weekName}}</span><time>{{plan.timeFrom}} – {{plan.timeTo}}</time></div></div><span v-else class="class-muted">暂无固定上课时间</span></td>
              <td><span class="class-status" :class="{'class-status-active':item.status === '1','class-status-disabled':item.status === '0'}">{{classStatusName(item.status)}}</span></td>
              <td class="class-number-cell"><strong class="class-quantity">{{item.studentQty == null ? '—' : item.studentQty}}</strong></td>
              <td class="class-number-cell">{{item.totalTimes == null ? '—' : item.totalTimes}}</td>
              <td class="class-number-cell">{{item.approvedTimes == null ? '—' : item.approvedTimes}}</td>
              <td><button type="button" class="class-detail-action" @click="showDetail(item)">班级详情<v-icon size="15">mdi-chevron-right</v-icon></button></td>
            </tr>
            <tr v-if="!data.list.length"><td colspan="10" class="class-empty" role="status"><v-icon size="30">mdi-google-classroom</v-icon><p>{{query.loading ? '正在加载班级，请稍候…' : '暂无符合条件的班级'}}</p><span v-if="!query.loading">可调整筛选条件，或点击“开班排课”创建班级</span></td></tr>
          </tbody>
        </table>
      </div>
      <div class="class-pagination"><div class="class-page-total"><span>共 <strong>{{data.total}}</strong> 项</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details aria-label="每页数量" label="每页数量" outlined v-model="query.size" /></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div>
    </section>
    <classDetail :show="detail.show" :classId="detail.classId" @cancel="detail.show=false" />
    <createClass :show="createClass.show" @cancel="createClass.show=false" @success="createClassSuccess" />
  </div>
</template>

<script>
	import global from '../../../config/global'
	import utils from '../../../config/utils'
	import createClass from "../../../components/create_class.vue"
	import classDetail from "../../../components/class_detail.vue"
	export default {
		name: "class-list",
		components:{classDetail,createClass},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				menu3: false, // 上课时间menu
				menu4: false, // 下课时间menu
				menu5: false, // 开课日期menu
				imgPrev: global.config.imgPre,
				itemIndex:0,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '班级管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '扣费方式',
							value: 'consumeType',
							sortable: false
						},
						{
							text: '班级名称',
							value: 'className',
							sortable: false
						},
						{
							text: '主课老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '助教老师',
							value: 'secondTeacherName',
							sortable: false
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '上课时间',
							value: 'timePlanList',
							sortable: false,
							width:"100px"
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '学员数',
							value: 'studentQty',
							sortable: false
						},
						{
							text: '总课次',
							value: 'totalTimes',
							sortable: false
						},
						{
							text: '已上课次',
							value: 'approvedTimes',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"正常"},
					{id:"0",statusName:"停用"},
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					className: "",
					status:"1",
					courseId:"",
					minLessonCount:"",
					maxLessonCount:""
				},
				detail:{
					// 详情页组件
					show:false,
					classId:""
				},
				createClass:{
					show:false
				}
			}
		},
		created() {

			// 接收传入的剩余课次
			let minCount = this.$route.query.minLessonCount;
			let maxCount = this.$route.query.maxLessonCount;
			if (minCount&&maxCount){
				this.query.minLessonCount = minCount;
				this.query.maxLessonCount = maxCount;
			}

			console.log("minCount,maxCount",minCount,maxCount);

			this.getTableDataList();
			this.getCourseListForSelect();


		},
		methods: {
			resetQuery(){
				Object.assign(this.query,{page:1,start:"",end:"",className:"",status:"1",courseId:"",minLessonCount:"",maxLessonCount:""});
				this.menu1 = false;
				this.menu2 = false;
				this.getTableDataList();
			},
			consumeTypeName(state){
				let stName = "未知";
				if (state === "1") {
					stName = "按课时扣费";
				} else if (state === "2") {
					stName = "按金额扣费";
				}
				return stName;
			},
			consumeTypeColor(state){
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}

				return color;
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},

			showDetail(item){
				this.detail.show = true;
				this.detail.classId = item.id;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();

				let url = `/edu/class/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.className) {
					url += "&className=" + this.query.className;
				}

				if (this.query.status){
					url += "&status="+this.query.status;
				}
				if (this.query.courseId){
					url += "&courseId="+this.query.courseId;
				}
				if (this.query.minLessonCount){
					url += "&minLessonCount="+this.query.minLessonCount;
				}
				if (this.query.maxLessonCount){
					url += "&maxLessonCount="+this.query.maxLessonCount;
				}

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			classStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "停用";
				}
				return stName;
			},
			classStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			createClassSuccess(){
				this.createClass.show= false;
				this.getTableDataList();
			},
			getCourseListForSelect() {

				const shopId = utils.getCurrentShopId();
				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/course/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>

<style scoped lang="scss" src="../../../assets/styles/class-management.scss"></style>
